import  AnimatedTestimonials  from "../../ui/AnimatedTesti";
import image3 from '../../assets/images/image3.jpeg';
import image9 from '../../assets/images/image9.jpg';
import image6 from '../../assets/images/image6.jpeg';
import image7 from '../../assets/images/image7.jpg';
import image8 from '../../assets/images/image8.jpg';


export function Testimonials() {
  const testimonials = [
    {
      quote:
        "My son was shy to speak in English, but after joining the phonics class, he started reading small words by herself. Now he is excited to show us new words every day. Very happy with the progress!",
      name: "Kamalesh",
      designation: "",
src: image8,
    },
    {
      quote:
        "At first I thought online class will not suit my daughter, but the way teacher handled with games and activities, she enjoyed every session. Now she is able to blend sounds and read simple sentences. Really useful!",
      name: "Manikandan",
      designation: "",
      src: image3,
    },
    {
      quote:
        "My child used to struggle with letters, but after the demo and classes, she quickly picked up the sounds. Within a few weeks, she started reading storybooks on her own. We are so thankful!",
      name: "Reena",
      designation: "",
src: image6,
    },
    {
      quote:
        "Before joining, my daughter was not showing interest in reading. But after the phonics classes, she is asking for books daily and reading loudly with confidence. Very satisfied with the improvement!",
      name: "Suresh",
      designation: "",
src: image9,
    },
    {
      quote:
        "The classes are very interactive. My daughter enjoys the songs and actions while learning phonics. We can clearly see the difference in her pronunciation and speaking skills. Worth joining!",
      name: "Anitha",
      designation: "",
src: image7,
    },
  ];
  return <AnimatedTestimonials testimonials={testimonials} />;
}
